import { createLogger } from '@wxu/logger';

export const logger = createLogger('pc-to-html');
